import { Trans } from 'next-i18next';
interface GetBannerTextParams {
  isAuth: boolean;
  isLineFinished: boolean;
  isLineNotStarted: boolean;
}
export const getBannerText = ({
  isAuth,
  isLineFinished,
  isLineNotStarted
}: GetBannerTextParams) => {
  if (!isAuth) {
    return <Trans i18nKey="widget.please_login" ns="sport">
        Please login or register
      </Trans>;
  }
  if (isAuth && isLineFinished) {
    return <Trans i18nKey="widget.broadcast_is_over" ns="sport" components={[<br key={1} />]}>
        {'The broadcast has ended.<0></0>Match over.'}
      </Trans>;
  }
  if (isAuth && isLineNotStarted) {
    return <Trans i18nKey="widget.broadcast_not_started" ns="sport">
        The broadcast has not started
      </Trans>;
  }
  return null;
};